import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export const checkPasswords: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const password = group.get('password')?.value;
    const passwordConfirm = group.get('passwordConfirm')?.value;

    return password === passwordConfirm ? null : { notSame: true };
};